import { Aspect } from '@teambit/harmony';

export const MDXAspect = Aspect.create({
  id: 'teambit.mdx/mdx',
});

export default MDXAspect;
